import { PaginationInputDto } from "@/model/common/PaginatedInputDto";
import { InvoiceNumberSequence } from "@/types/invoiceNumberSeq.types";
import { post, del,get } from "../../utils/BaseService";

export interface TenantPaginationDto extends PaginationInputDto {
  tenantId?: number|null;
}
export async function getAllSequences(dispatch: any, props: TenantPaginationDto) {
  return await post(dispatch, '/sequence/getAllSequences', props);
}

export async function getSequenceById(dispatch: any, id: string) {
  return await get(dispatch, `/sequence/getSequenceById/${id}`, null);
}

export async function createSequence(dispatch: any, props: Omit<InvoiceNumberSequence, 'sequence_id' | 'last_reset_date'>) {
  return await post(dispatch, "/sequence/createSequence", props);
}

export async function updateSequence(dispatch: any, id: string, props: Partial<InvoiceNumberSequence>) {
  return await post(dispatch, `/sequence/updateSequence/${id}`, props);
}

export async function deleteSequence(dispatch: any, id: string) {
  return await del(dispatch, `/sequence/deleteSequence/${id}`, parseInt(id));
}

export async function setDefaultSequence(dispatch: any, id: string) {
  return await post(dispatch, `/sequence/setDefaultSequence/${id}`, null);
}